<template>
  <b-container>
    <b-row>
      <b-col class="fonsVermell">{{ items[0].menorQue }}</b-col>
      <b-col class="fonsGroc">{{ items[0].majorYMenorQue }}</b-col>
      <b-col class="fonsVerd">{{ items[0].majorQue }}</b-col>
      <div></div>
      <b-col class="fonsVermell">Necessitat de millora</b-col>
      <b-col class="fonsGroc"></b-col>
      <b-col class="fonsVerd">Nivell d'excel-lència</b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "LlegendaIndicadorPositiu",
  data() {
    return {
      items: [
        {
          menorQue: '<75%',
          majorYMenorQue: '75%><90%',
          majorQue: '>90%'
        }
      ]
    }
  }
}
</script>

<style scoped>

.fonsVermell {
  background-color: #FF0000;
  font-weight: bold;
  border: 1px solid black;
}

.fonsGroc {
  background-color: #FFC000;
  font-weight: bold;
  border: 1px solid black;
}

.fonsVerd {
  background-color: #2AA901;
  font-weight: bold;
  border: 1px solid black;
}

</style>